import React, { Component } from "react";
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import _ from "lodash";
import BasicInformation from "./basic-information";
import IndicatorSubItem from "./indicator-subitem";
import AnalyticalConfiguration from "./analytical-configuration";
import { withNotification } from "../../notification/context";
import { withStyles, Fab } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import BackIcon from "@material-ui/icons/ArrowBack";

const styles = (theme) => ({
	root: {
		position: "relative",
		margin: 36
	},
	fab: {
		position: "fixed",
		top: 0,
		left: 0,
		transform: `translateX(${10}%) translateY(${150}%)`
	}
});

const GET_INDICATORS = gql`
	{
		allIndicators {
			_id
			name
			description
			paletteType
			deleted
		}
	}
`;

const SINGLE_INDICATOR = gql`
	query Indicator($id: ID!) {
		indicator(id: $id) {
			_id
			id
			name
			description
			paletteType
			tags {
				_id
				name
				description
			}
			generalities {
				description
				files {
					id
					name
				}
			}
			inequalities {
				description
				files {
					id
					name
				}
			}
			deleted
			stratifiers {
				id
				name
				order
			}
			demographicVariable
			order
			constant
		}
	}
`;

const UPDATE_ITEM = gql`
	mutation($id: ID!, $indicator: IndicatorInput!) {
		editIndicator(id: $id, indicator: $indicator) {
			_id
			id
			name
			description
			paletteType
			tags {
				_id
				name
				description
			}
			generalities {
				description
				files {
					name
					id
				}
			}
			inequalities {
				description
				files {
					name
					id
				}
			}
			deleted
			stratifiers {
				id
				name
				order
			}
			demographicVariable
			order
			constant
		}
	}
`;

function cleanIndicator(indicator) {
	const {
		name,
		description,
		paletteType,
		generalities,
		inequalities,
		tags,
		stratifiers,
		demographicVariable,
		order,
		constant
	} = indicator;
	return {
		name,
		description,
		paletteType,
		generalities: _.omit(generalities, ["__typename"]),
		inequalities: _.omit(inequalities, ["__typename"]),
		tags,
		stratifiers,
		demographicVariable,
		order,
		constant
	};
}

class IndicatorDetails extends Component {
	render() {
		const {
			match: { params: id },
			openNotification,
			classes,
			history
		} = this.props;

		return (
			<Mutation
				mutation={UPDATE_ITEM}
				update={(cache, { data: { editIndicator } }) => {
					cache.writeQuery({
						query: SINGLE_INDICATOR,
						data: { indicator: editIndicator }
					});
				}}
				refetchQueries={() => [
					{ query: SINGLE_INDICATOR, variables: { ...id } },
					{ query: GET_INDICATORS }
				]}
				onCompleted={() => openNotification("Datos actualizados correctamente")}
			>
				{(editItem) => {
					return (
						<Query
							query={SINGLE_INDICATOR}
							variables={{ ...id }}
							fetchPolicy="cache-and-network"
						>
							{({ loading, error, data }) => {
								if (loading) return null;
								if (error) return `Error!: ${error}`;
								const indicatorClean = cleanIndicator(data.indicator);

								return (
									<div className={classes.root}>
										<Fab
											className={classes.fab}
											color={"primary"}
											onClick={() => null}
										>
											<BackIcon
												onClick={() => history.push("/admin/indicators")}
											/>
										</Fab>
										<BasicInformation
											indicatorId={data.indicator._id}
											indicator={indicatorClean}
											onSubmit={editItem}
										/>
										<IndicatorSubItem
											indicatorId={data.indicator._id}
											subItemKey="generalities"
											subItemTitle="Generalidades"
											indicator={indicatorClean}
											onSubmit={editItem}
										/>
										<IndicatorSubItem
											indicatorId={data.indicator._id}
											subItemKey="inequalities"
											subItemTitle="Desigualdades"
											indicator={indicatorClean}
											onSubmit={editItem}
										/>
										<AnalyticalConfiguration
											indicatorId={data.indicator._id}
											indicator={indicatorClean}
											onSubmit={editItem}
										/>
									</div>
								);
							}}
						</Query>
					);
				}}
			</Mutation>
		);
	}
}

export default withRouter(
	withStyles(styles)(withNotification(IndicatorDetails))
);



// WEBPACK FOOTER //
// ./src/components/admin/indicators/details.js